import { Autocomplete, Chip, TextField } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'

interface IFilter {
  brandsL: any
  countriesL: any
  provinceL: any
  postalcodesL: any
  brandsR: any
  countriesR: any
  provinceR: any
  postalcodesR: any
  typeLink: number
}

interface UserTransferFiltersProps {
  filters: IFilter
  handleAutoCompleteChange: any
  handleMultiAutoCompleteChange: any
}

export function UserTransferFilters({
  filters,
  handleAutoCompleteChange,
  handleMultiAutoCompleteChange
}: UserTransferFiltersProps) {
  const { t } = useTranslation(['global'])

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { countries, provinces, postalcodes } = useSelector((state: IRootState) => state.country)
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  return (
    <Grid container spacing={2}>
      <Grid xs={12} md={true}>
        <Grid container spacing={2}>
          <Grid xs={12} md={6}>
            <Autocomplete
              id="combo-box-brandsL"
              ChipProps={{ color: 'secondary' }}
              value={userBrands.filter((brand: any) => filters.brandsL.includes(brand.id))}
              onChange={handleMultiAutoCompleteChange('brandsL')}
              options={userBrands}
              multiple
              getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => <Chip label={option.name} {...getTagProps({ index })} />)
              }
              renderInput={params => (
                <TextField {...params} label={t('brands')} variant="filled" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <Autocomplete
              id="combo-box-countriesL"
              ChipProps={{ color: 'secondary' }}
              value={countries.filter((country: any) => filters.countriesL.includes(country.id))}
              onChange={handleMultiAutoCompleteChange('countriesL')}
              options={
                authUser.role_id >= 2
                  ? countries.filter((country: any) => authUser.countries.includes(country.id))
                  : countries
              }
              multiple
              getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => <Chip color="secondary" label={option.name} {...getTagProps({ index })} />)
              }
              renderInput={params => (
                <TextField {...params} label={t('countries')} variant="filled" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <Autocomplete
              id="combo-box-provincesL"
              value={filters.provinceL}
              onChange={handleAutoCompleteChange('provinceL')}
              options={provinces.filter((province: any) => filters.countriesL.includes(province.country_id))}
              getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
              renderInput={params => (
                <TextField {...params} label={t('province')} variant="filled" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <Autocomplete
              id="combo-box-postalcodesL"
              value={postalcodes.filter((postalcode: any) => filters.postalcodesL.includes(postalcode.code))}
              onChange={handleMultiAutoCompleteChange('postalcodesL')}
              options={postalcodes.filter((postalcode: any) => filters.provinceL.id === postalcode.province_id)}
              multiple
              getOptionLabel={(option: any) => (option.id !== undefined ? option.code : '')}
              renderInput={params => (
                <TextField {...params} label={t('postalcode')} variant="filled" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* --------------------------------------------------------- */}

      <Grid xs={12} md={1}>
        {' '}
      </Grid>

      <Grid xs={12} md={true}>
        <Grid container spacing={2}>
          <Grid xs={12} md={6}>
            <Autocomplete
              id="combo-box-brandsR"
              ChipProps={{ color: 'secondary' }}
              value={userBrands.filter((brand: any) => filters.brandsR.includes(brand.id))}
              onChange={handleMultiAutoCompleteChange('brandsR')}
              options={userBrands}
              multiple
              getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => <Chip label={option.name} {...getTagProps({ index })} />)
              }
              renderInput={params => (
                <TextField {...params} label={t('brands')} variant="filled" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <Autocomplete
              id="combo-box-countriesR"
              ChipProps={{ color: 'secondary' }}
              value={countries.filter((country: any) => filters.countriesR.includes(country.id))}
              onChange={handleMultiAutoCompleteChange('countriesR')}
              options={
                authUser.role_id >= 2
                  ? countries.filter((country: any) => authUser.countries.includes(country.id))
                  : countries
              }
              multiple
              getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => <Chip color="secondary" label={option.name} {...getTagProps({ index })} />)
              }
              renderInput={params => (
                <TextField {...params} label={t('countries')} variant="filled" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <Autocomplete
              id="combo-box-provincesR"
              value={filters.provinceR}
              onChange={handleAutoCompleteChange('provinceR')}
              options={provinces.filter((province: any) => filters.countriesR.includes(province.country_id))}
              getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
              renderInput={params => (
                <TextField {...params} label={t('province')} variant="filled" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <Autocomplete
              id="combo-box-postalcodesR"
              value={postalcodes.filter((postalcode: any) => filters.postalcodesR.includes(postalcode.code))}
              onChange={handleMultiAutoCompleteChange('postalcodesR')}
              options={postalcodes.filter((postalcode: any) => filters.provinceR.id === postalcode.province_id)}
              multiple
              getOptionLabel={(option: any) => (option.id !== undefined ? option.code : '')}
              renderInput={params => (
                <TextField {...params} label={t('postalcode')} variant="filled" InputLabelProps={{ shrink: true }} />
              )}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
